import classNames from 'classnames'
import React, { useCallback } from 'react'

import { Icon } from '../icon'

import styles from './chip.module.scss'
import CrossIcon from './icons/cross.inline.svg'

interface ChipProps {
  label: string
  active?: boolean
  closeable?: boolean
  onClose?: () => void
  onClick?: () => void
  disabled?: boolean
  className?: string
  'data-testid'?: string
}

export const Chip: React.FC<ChipProps> = ({
  label,
  active = false,
  closeable = false,
  onClose,
  onClick,
  disabled = false,
  className = '',
  'data-testid': testId,
}) => {
  const handleClick = () => {
    if (disabled) return
    if (onClick) onClick()
  }

  const handleClose = useCallback(
    (e: React.MouseEvent) => {
      e.stopPropagation()
      if (!disabled && onClose) onClose()
    },
    [disabled, onClose],
  )

  return (
    <div
      className={`${styles.chip} ${active ? styles.active : ''} ${closeable ? styles.dismissable : ''} ${disabled ? styles.disabled : ''} ${className}`}
      onClick={handleClick}
      role="button"
      aria-pressed={active}
      aria-disabled={disabled}
      tabIndex={disabled ? -1 : 0}
      title={label.length > 12 ? label : undefined}
      data-testid={testId}
    >
      <span className={styles.chipLabel}>{label}</span>
      {closeable && (
        <button
          className={classNames(styles.dismissButton, 'dismissButton')}
          onClick={handleClose}
          aria-label={`Close ${label}`}
          disabled={disabled}
          data-testid={testId ? `${testId}-dismiss` : undefined}
        >
          <Icon iconSvg={CrossIcon} className={styles.dismissIcon} />
        </button>
      )}
    </div>
  )
}
